// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UploadButton_wrapper__3HdKW"};